// Vanilla CSS for InputWithSpecialExpression. Prefix: txt-. Aggregated into libraryStyles.
export const textStyles = `
  .txt-se-wrap { margin: 0.5rem; }
  .txt-se-pre { white-space: pre-wrap; }
  .txt-se-bold { font-weight: 600; }
  .txt-se-underline { text-decoration: underline; }
  .txt-se-eq { font-size: var(--fs-lg); }
`;
